import React, { useState } from 'react'
import { createSelector } from 'reselect'
import { useDispatch, useSelector } from 'react-redux'
import { Close, LocationOn } from '@material-ui/icons'
import { Box, Button, Dialog, IconButton, makeStyles, Typography, useTheme } from '@material-ui/core'

import { useLiterals } from '~/components/Literals'
import useViewportSizes from '~/components/useViewportSize'
import SearchAddress from '~/components/Autocomplete/SearchAddress'
import actions from '~/actions'
import { digitarEndereco, compartilharEndereco } from '~/track'
import logo from '~/assets/new_gofind/logoMap.svg'

import DialogContent from './DialogContent'
import ButtonPosition from './ButtonPosition'
import Mobile from './Mobile'

const useStyle = makeStyles((theme) => ({
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    maxHeight: 100,
    maxWidth: '100%',
  },
  inputAddress: {
    width: '100%',
  },
  button: {
    '& .MuiMuiButton-label': {
      justifyContent: 'space-between',
    },
  },
  buttonLabel: {
    justifyContent: 'flex-start',
    fontSize: 14,
    color: theme.palette.text.hint,
    textTransform: 'none',
  },
  buttonRoot: {
    boxShadow: theme.shadows[3],
  },
  gofindlogo: {
    height: 19,
  },
}))

const selector = createSelector(
  (state) => state.config,
  (state) => state.position,
  (config, position) => ({ config, position }),
)
export default function PositionDialog() {
  const {
    config: { imageUrl, showContextViewEstablishment = false },
    position: { showPositionDialog, user },
  } = useSelector(selector)

  const theme = useTheme()
  const viewport = useViewportSizes()
  const { getLiteral } = useLiterals()
  const dispatch = useDispatch()

  const isMobile = viewport.width < theme.gofind.desktopMaxWidth
  const [showMobile, setShowMobile] = useState(false)

  const classes = useStyle({ hasClose: user?.lat && user?.lng })

  const handleChangeLocation = (location) => {
    dispatch(actions.position.change({ user: location, showPositionDialog: false }))
    setShowMobile(false)
  }

  const handleShareLocation = (location) => {
    compartilharEndereco(location) // track
    handleChangeLocation(location)
  }

  const handleSearchLocation = (location) => {
    digitarEndereco() // track
    handleChangeLocation(location)
  }

  const handleCloseDialog = () => {
    dispatch(actions.position.change({ showPositionDialog: false }))
  }

  return (
    <>
      <Dialog open={showPositionDialog} scroll="body" disableAutoFocus>
        {user?.lat && user?.lng && (
          <IconButton
            onClick={handleCloseDialog}
            size="small"
            style={{
              position: 'absolute',
              top: isMobile ? 0 : 4,
              right: isMobile ? 0 : 4,
              cursor: 'pointer',
              zIndex: 1,
            }}
          >
            <Close />
          </IconButton>
        )}
        <DialogContent isMobile={isMobile}>
          <Box className={classes.dialogContent}>
            <img src={imageUrl} className={classes.logo} />

            <Typography component="div" style={{ margin: '16px 0' }}>
              <Box textAlign="center" style={{ maxWidth: 234 }}>
                {showContextViewEstablishment ? getLiteral('2544') : getLiteral('2507')}
              </Box>
            </Typography>

            <Box className={classes.inputAddress}>
              {isMobile ? (
                <Button
                  classes={{
                    root: classes.buttonRoot,
                    label: classes.buttonLabel,
                  }}
                  startIcon={<LocationOn style={{ fontSize: 14, color: theme.palette.primary.main }} />}
                  size="large"
                  fullWidth
                  variant="outlined"
                  onClick={() => setShowMobile(true)}
                >
                  {getLiteral('3316')}
                </Button>
              ) : (
                <SearchAddress onChangeLocation={handleSearchLocation} placeholder={getLiteral('3316')} />
              )}
            </Box>

            {!isMobile && (
              <Box style={{ marginTop: 16 }}>
                <ButtonPosition onChangeLocation={handleShareLocation} />
              </Box>
            )}

            <Box
              display="flex"
              alignItems="center"
              style={{ gap: 8, marginBlock: 16, flexDirection: isMobile ? 'column' : 'row' }}
            >
              <Typography style={{ fontSize: 14 }}>{getLiteral('2551')}</Typography>
              <img src={logo} className={classes.gofindlogo} />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <Mobile
        open={showPositionDialog && showMobile}
        onClose={() => setShowMobile(false)}
        onChangeLocation={handleChangeLocation}
      />
    </>
  )
}
